<template>
<div style="background: #F6F6F6;padding-bottom: 30px;">
	<ZYtoolsHead></ZYtoolsHead>
	<div class="wrap">
	
		<router-view></router-view>
	</div>
</div>
</template>

<script>
import store from '../../store/index.js'
import ZYtoolsHead from '../../components/ZYtoolsHead.vue'
export default{
	name:'ZyTools',
	components:{
		 ZYtoolsHead,
	},
	data(){
		return{
			title:'',
			whereForm:"",
		}
	},

	beforeRouteEnter(to, from, next){
		if(to.meta.keepAlive){
			store.commit( "ADD_CachePage", "ZyTools")
		}
		next()
	},
	beforeRouteUpdate(to,from,next) {
		if(to.meta.keepAlive){
			store.commit( "ADD_CachePage", "ZyTools")
		}
		next() 
	},
	beforeRouteLeave(to, from, next){
		if(!to.meta.editor){
			this.$store.commit('Del_CachePage')
		}
		next()
	},

}
</script>

<style scoped lang="less">

</style>